module.exports = __webpack_public_path__ + "img/Lee_Street_Lofts_Interior_0083.1f1a5ab2.jpg";